import { render, staticRenderFns } from "./edit-sender.vue?vue&type=template&id=e0bb9696"
import script from "./edit-sender.vue?vue&type=script&lang=ts"
export * from "./edit-sender.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports